<div class="profile-img-con" *ngIf="user">
    <div class="profile-placeholder caption black"  [ngStyle]="{'background-color':user.bg}" *ngIf="!user.profileImg">
        <div [ngStyle]="{'font-size':fontSize?fontSize+'px':'inherit'}">{{user.initials}}</div>
    </div>
    <img src="{{user.profileImg}}" *ngIf="user.profileImg" class="profileImg" (click)="onClick()" />
    <div class="img-edit-con" (click)="onFileClick()" *ngIf="canEdit">
        <mat-icon>edit</mat-icon>
    </div>
</div>
